
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/hotdesks",
      function () {
        return require("private-next-pages/features/hotdesks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/hotdesks"])
      });
    }
  